export default __webpack_public_path__ + "static/media/plan_img.96769719.png";